import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmissionValidationIssue } from '../../../../models/Study/submission-validation-issue.model';

/**
 * Shown when a study fails submit validation.
 *
 * Replaces a toaster that collapsed every reason onto one line. The validator
 * returns ALL applicable issues, so a study that is both short of its X-Ray
 * protocol and missing a scope video reports both here at once rather than
 * surfacing them one submit at a time.
 */
@Component({
  selector: 'app-submission-validation-popup',
  templateUrl: './submission-validation-popup.component.html',
  styleUrls: ['./submission-validation-popup.component.scss'],
})
export class SubmissionValidationPopupComponent {
  @Input() issues: SubmissionValidationIssue[] = [];
  @Input() lotOrHipText = 'Lot';
  @Input() lot: string;
  @Input() horseName: string;

  constructor(public modal: NgbActiveModal) {}
}
